import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PrimeReactProvider } from 'primereact/api'
import { PersistGate } from 'redux-persist/integration/react'
import { ConfirmDialog } from 'primereact/confirmdialog'

import { LocalizationProvider } from '../common/components/localization-provider'
import { ThemeProvider } from '../common/components/theme-provider'
import { ToastProvider } from '../common/uikit/ToastProvider'

import { persistor, store } from './redux/store'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <ThemeProvider>
        <Suspense fallback={<div />}>
            <LocalizationProvider>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <PrimeReactProvider>
                            <ToastProvider>
                                <BrowserRouter basename="support">
                                    <App />
                                    <ConfirmDialog
                                        style={{ width: '40vw' }}
                                        breakpoints={{ '1100px': '75vw', '960px': '100vw' }}
                                    />
                                </BrowserRouter>
                            </ToastProvider>
                        </PrimeReactProvider>
                    </PersistGate>
                </Provider>
            </LocalizationProvider>
        </Suspense>
    </ThemeProvider>
)
